import { useEffect } from "react";
import TermlyEmbed from "./TermlyEmbed";

const CookiePolicy = () => {
  useEffect(() => {
    document.title = "Cookie Policy | Kloudscan";
  }, []);

  return <TermlyEmbed policyId="a40a2f83-97b2-4eb9-b32f-7988c8fb6003" label="Cookie Policy" />;
};

export default CookiePolicy;
